import { useState, useMemo } from 'react'
import { Container, Header, Content } from './styled';
import { FiChevronDown } from 'react-icons/fi';



export function InputList(props) {

    const {
        options,
        value,
        onChange,
        disable,
        toView,
        onClick,
        className
    } = props;
    const [open, setOpen] = useState(false);

    function handClick(item) {
        setOpen(false);
        onChange(item);
    }

    const myStateElements = useMemo(() => options?.map((item) => (
        <li
            key={item?.id}
            onClick={() => handClick(item)}
        >
            {item[toView]}
        </li>
    )), [options]);

    return (
        <Container
            className={className}
            disable={disable}
            onClick={onClick}
        >
            <Header onClick={() => setOpen(!open)}>
                <input value={value} onChange={onChange} />
                <span>
                    <FiChevronDown />
                </span>
            </Header>
            <Content isOpen={open}>
                <ul>
                    {myStateElements}
                </ul>
            </Content>
        </Container>
    );


}